export default __webpack_public_path__ + "static/coperta-memoria-gustului-2650e38701dbfc3ec52beab254a390da.jpg";